export { default } from './Proportion.js';
